/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import {
  Row,
  Col
} from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import tablePaquetes from '../../views/paquetes/paquetes.table';
import numeral from 'numeral';
import { v4 as uuidv4 } from 'uuid';
import notification from '../notification.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import detalleFunction from '../../views/detalle/detalle.function';
import { ConfigContext } from '../../context/config.context';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import utils from '../../utils/utils.functions';
import BultosModalGuia from '../bultos-modal-guia/BultosModalGuia';

const BultosMod = ({ data, onClose, onUpdate }) => {

  const inititalBultos = {
    alto: 0,
    ancho: 0,
    largo: 0,
    peso: 0,
    pies: 0,
    guia_externa: '',
    uuid: null,
  }

  const { setPreloader } = useContext(ConfigContextUtils);
  const [bultosDatos, setBultosDatos] = useState(inititalBultos);
  const [bultos, setBultos] = useState([]);
  const [editBultos, setEditoBultos] = useState(false);
  const { config } = useContext(ConfigContext);
  const [modalBultos, setModalBultos] = useState(false);
  const [dataModalBultos, setDataModalBultos] = useState(null);

  const guardarBultos = () => {
    if (bultos.length) { 
      setPreloader(true);
      detalleFunction.bultos({ guia_id: data.id, bultos }).then((respuesta) => {
        if (respuesta.bultos_actualizados) {
          notification.success();
          onUpdate();
          onClose();
         } else {
          notification.waring('Los bultos no fueron actualizados');
         }
         setPreloader(false);
      })
    } else {
      notification.warning('Debe agregar los bultos a la guia')
    }
  }


  useEffect(() => {
    const valuesBultos = data.bultos.map((e) => ({
      alto: numeral(e.alto).format('0.00'),
      ancho: numeral(e.ancho).format('0.00'),
      largo: numeral(e.largo).format('0.00'),
      pie: numeral(e.pie).format('0.00'),
      peso: numeral(e.peso).format('0.00'),
      guia_externa: e.guia_externa || '',
      uuid: uuidv4(),
    }));
    setBultos(valuesBultos);
  },[])


  const agregarBultos = () => {
    if (bultosDatos.alto !== '' &&
        bultosDatos.ancho !== '' &&
        bultosDatos.largo !== '' &&
        bultosDatos.peso !== '' &&
        bultosDatos.peso > 0) {
        setBultos([
        {
          alto: numeral(bultosDatos.alto).format('0.00'), 
          ancho: numeral(bultosDatos.ancho).format('0.00'),
          largo: numeral(bultosDatos.largo).format('0.00'),
          peso: numeral(bultosDatos.peso).format('0.00'),
          pie: calculatePieCubico(),
          uuid: bultosDatos.uuid,
        },
        ...bultos,
      ]);
      setBultosDatos(inititalBultos);
    } else {
      notification.warning('Complete la información para agregar un bulto');
    }
  }

  const calculatePieCubico = () => {
    let piesCubico = utils.calculatePiesCubicos(
      bultosDatos.alto,
      bultosDatos.ancho,
      bultosDatos.largo,
      config.formula_pies_cubicos
     );
    return piesCubico;
  }

  const removeBultos = (row) => {
    const index = bultos.findIndex((e) => e.uuid === row.uuid);
    const updateElement = [...bultos];
    updateElement.splice(index, 1);
    setBultos(updateElement);
  }

  const setValuesBultos = (element) => {
    setBultosDatos({
      ...bultosDatos,
      [element.target.name]: element.target.value,
    })
  }

  const editarBultos = (row) => {
    setBultosDatos(row);
    setEditoBultos(true);
  }

  const calcelareditBultos = () => {
    setBultosDatos(inititalBultos);
    setEditoBultos(false);
  }

  const confirmareditBultos = () => {
     const indexBulto = bultos.findIndex(val => val.uuid === bultosDatos.uuid);
     const clonBultos = [...bultos];
     clonBultos[indexBulto] = {...bultosDatos, pie: calculatePieCubico() };
     setBultos(clonBultos);
     calcelareditBultos();
  }

  const callbackBultos = (value) => {
    const cloneBulto = [...bultos];
    const findIndex = cloneBulto.findIndex(item => item.uuid === dataModalBultos.uuid);
    cloneBulto[findIndex].guia_externa = value.toUpperCase().trim();
    setBultos(cloneBulto);
    setModalBultos(false);
    setDataModalBultos(null);
  }

  const callbackModalBultos = (dataBulto) => {
    setDataModalBultos(dataBulto);
  };

  useEffect(() => {
    if (dataModalBultos) {
      setModalBultos(true);
    }
  },[dataModalBultos]);

  const resetModalBultos = () => {
    setModalBultos(false);
    setDataModalBultos(null);
  }

  return (
    <>
        <Row>
           <Col>Las medidas deben ser en Centimetros y usar para el separador punto (.)</Col>
         </Row>
        <Row>
          <Col lg={2}>
            <div className="grupo-input">
              <small>Alto (cm)</small>
              <input type="text"
                className={`form-control input-border`}
                name="alto"
                onChange={setValuesBultos}
                value={bultosDatos.alto}
                />
            </div>
          </Col>
          <Col lg={2}>
            <div className="grupo-input">
              <small>Ancho (cm)</small>
              <input type="text"
                className={`form-control input-border`}
                name="ancho"
                onChange={setValuesBultos}
                value={bultosDatos.ancho}
                />
            </div>
          </Col>
          <Col lg={2}>
            <div className="grupo-input">
              <small>Largo (cm)</small>
              <input type="text"
                className={`form-control input-border`}
                name="largo"
                onChange={setValuesBultos}
                value={bultosDatos.largo}
                />
            </div>
          </Col>
          <Col lg={4}>
            <div className="grupo-input">
              <small>Peso (Kg)</small>
              <div className="d-flex">
              <input type="text"
                className={`form-control input-border`}
                name="peso"
                onChange={setValuesBultos}
                value={bultosDatos.peso}
                />
               {!editBultos ?  
              <button onClick={agregarBultos} type="button" className="btnx btnx-warn icon-table">
                <FontAwesomeIcon icon={faPlus} />
              </button>
              : 
              <>
                <button onClick={confirmareditBultos} type="button" className="btnx btnx-warn icon-table">
                   <FontAwesomeIcon icon={faCheck} />
                </button>
                <button onClick={calcelareditBultos} type="button" className="btnx btnx-warn icon-table">
                  Cancelar
                </button>
              </>
              }
              </div>
            </div>
          </Col>
          <Col className="bultosText">
            Bultos {bultos.length}
          </Col>
        </Row>
        <Row>
          <Col className="mt-2">
          <DataTable
            noHeader={true}
            customStyles={tablePaquetes.customStyles}
            columns={tablePaquetes.colummnsBultos(removeBultos, editarBultos, callbackModalBultos, utils.obtenerValorPermiso('UNIT_BOX_GUIDE', config.operaciones))}
            data={bultos}
            dense={true}
            pagination={true}
            paginationPerPage={5}
          />
         </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end mt-3">
            <button onClick={guardarBultos} type="button" className="btnx btnx-warn mr-2">Guardar</button>
            <button onClick={() => onClose()}  type="button" className="btnx btnx-warn">Cancelar</button>
          </Col>
        </Row>
        <BultosModalGuia
            show={modalBultos}
            onCancel={resetModalBultos}
            onConfirm={callbackBultos}
            currentValue={dataModalBultos}
            backdrop={true}
         />
    </>
  )
}

export default BultosMod;